import { NumberInput as NInput, type NumberInputProps as Props } from '@heroui/react';
import { type Control, Controller, type FieldValues, type Path } from 'react-hook-form';

export const NumberInput = (props: Props) => {
  return (
    <NInput
      // classNames={{ input: "text-default-800 placeholder:text-default-400" }}
      radius='sm'
      {...props}
    />
  );
};

export interface FormNumberInputProps<T extends FieldValues> extends Props {
  name: Path<T>;
  control: Control<T, unknown>;
  shouldUnregister?: boolean;
}

export const FormNumberInput = <T extends FieldValues>({
  control,
  name,
  shouldUnregister = undefined,
  ...rest
}: FormNumberInputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field: { onChange, onBlur, value }, fieldState: { error, invalid, isDirty } }) => {
        const onHandleChange = (value: number) => {
          onChange(value);
        };
        return (
          <NumberInput
            {...rest}
            value={value}
            isWheelDisabled
            onBlur={onBlur}
            onValueChange={onHandleChange}
            isInvalid={isDirty && invalid}
            errorMessage={error?.message}
          />
        );
      }}
    />
  );
};
